module.exports = __webpack_public_path__ + "img/tilda-white-big.9469b9fa.svg";